<template>
  <div class="home">
    <h1>🚀 廣告元件 開發者測試頁面 🚀</h1>
    <h2>目前版本：2.0</h2>
    <h3>元件預覽頁面（上傳素材預覽、樣張預覽）</h3>
    <a href="./proof.html">./proof.html</a>
    <h3>媒體端測試頁面</h3>
    <router-link
      :to="{
        name: 'MockPage',
        params: {
          device: 'PC',
          env: 'dev',
          channel: 'dev-channel'
        }
      }"
    >
      dev channel
    </router-link>
    <table border="1" :cellpadding="4">
      <thead>
        <tr>
          <th colspan="3">channel info</th>
          <th colspan="3">mock page</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="dName in ['PC', 'MOBILE', 'APP']">
          <template
            v-for="([sHash, sInfo], sIndex) in dataMaps.dMap.get(dName)"
          >
            <tr
              v-for="([cHash, cInfo], cIndex) in dataMaps.sMap.get(sHash)"
              :key="sHash + cHash"
            >
              <td
                v-if="sIndex === 0 && cIndex === 0"
                :rowspan="getDeviceRowspan(dName)"
              >
                {{ dName }}
              </td>
              <td v-if="cIndex === 0" :rowspan="dataMaps.sMap.get(sHash).size">
                {{ sInfo.name }}
              </td>
              <td>{{ cInfo.name }}</td>

              <td v-for="env of ['lab', 'staging', 'prod']" :key="env">
                <router-link
                  v-if="isChannelExistInEnv(cHash, env)"
                  :to="`/mock/${dName}/${cHash}/${env}`"
                >
                  {{ env }}
                </router-link>
                <span v-else>--</span>
              </td>
            </tr>
          </template>
        </template>
        <tr></tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "HomePage",
  components: {},
  data() {
    return {
      dataMaps: window.dataMaps
    };
  },
  methods: {
    getDeviceRowspan(dName) {
      let rowspan = 0;
      const sInfoMap = this.dataMaps.dMap.get(dName);
      sInfoMap.forEach((sInfo, sHash) => {
        rowspan += this.dataMaps.sMap.get(sHash).size;
      });
      return rowspan;
    },
    isChannelExistInEnv(cHash, env) {
      const boardsMap = this.dataMaps.cMap.get(cHash);

      let isExist = false;

      boardsMap.forEach(board => {
        if (board.env.has(env)) {
          isExist = true;
        }
      });

      return isExist;
    }
  }
};
</script>

<style>
table {
  border-collapse: collapse;
}
</style>
